import { useEffect } from "react";
import { useObjectStore } from "../zustand/objects";
import { useThree } from "@react-three/fiber";

export function CommentCursor({ threadsId, artboard }) {

    const { camera, raycaster, mouse, scene } = useThree();

    const {
            commentClickStatus,
            addThread,
            updateThread
        } = useObjectStore();

    useEffect(() => {
        const handleClick = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            raycaster.setFromCamera(mouse, camera);

            const intersects = raycaster.intersectObjects(scene.children, true);

            if (intersects.length > 0) {            
                const intersectionPoint = intersects[0].point;
                if (commentClickStatus.clicking === "add") {
                addThread(intersectionPoint)}
                else if (commentClickStatus.clicking === "move") {
                    updateThread(threadsId, artboard, intersectionPoint)
                }
            } else {
                return
            }
        };

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, [addThread, artboard, camera, commentClickStatus.clicking, mouse, raycaster, scene, threadsId, updateThread]);

    return null;
}


export function MoveCommentCursor({ threadsId, artboard, position }) {

    const { camera, raycaster, mouse, scene } = useThree();

    const {
            commentClickStatus,
            addThread,
            updateThread
        } = useObjectStore();

    useEffect(() => {
        const handleClick = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            raycaster.setFromCamera(mouse, camera);

            const intersects = raycaster.intersectObjects(scene.children, true);

            if (intersects.length > 0) {

                const intersectionPoint = intersects[0].point;
                if (commentClickStatus.clicking === "add") {
                addThread(intersectionPoint)}
                else if (commentClickStatus.clicking === "move") {
                    
                    updateThread(threadsId, artboard, position)
                }
            } else {
                return
            }
        };

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, [addThread, artboard, camera, commentClickStatus.clicking, mouse, position, raycaster, scene, threadsId, updateThread]);

    return null;
}